import React, { ChangeEvent } from "react";
import { useAccessibility } from "../../../../../Store/contexts/AccessibilityContext";
import DefaultButton from "../../../../../components/Accessibility/DefaultButton";
import { useFormik } from "formik";
import {
  Box,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import "../../styles.css";
import {
  GestaoDeCronicosStepsEnum,
  IResponseQuestionnaire,
} from "../../../../../interfaces/enum/GestaoDeCronicosEnum";
import { postSalvarIMC } from "../../../../../services/SaudeBemEstar/GestaoDeCronicosService";
import { sxTextField } from "./sxProps";
import * as Yup from "yup";
import { useGestaoDeCronicosCaptacao } from "../../context/CaptacaoContext";
import LoadingApp from "../../../../../components/LoadingApp";

export const QuestionarioIMC = () => {
  const { textStyleAccessibility, contrastMode, contrastStyle } =
    useAccessibility();
  const { loadingQuest, responseQuestionnaire, handleChangeStep } =
  useGestaoDeCronicosCaptacao();

  const formik = useFormik({
    initialValues: {
      personsHeight: "",
      personsWeight: "",
    },
    validationSchema: Yup.object({
      personsHeight: Yup.string()
        .required("Altura é obrigatória"),
      personsWeight: Yup.string()
        .required("Peso é obrigatório"),
    }),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      let data = {} as IResponseQuestionnaire["listaQuestoesImc"];
      if (responseQuestionnaire) {
        data = responseQuestionnaire.listaQuestoesImc.map((questao, index) => ({
          ...questao,
          codTipoTeleOrientacao: questao.codTipoTeleOrient,
          resposta: index === 0 ? values.personsHeight : values.personsWeight,
        }));
      }
      postSalvarIMC(data)
        .then((res: any) => {
          if (res !== null && res !== undefined)
            handleChangeStep(GestaoDeCronicosStepsEnum.resultadoIMC, {
              responseIMC: res,
            });
          formik.resetForm();
        })
        .catch((error) => {
          console.error("Erro ao salvar IMC:", error);
        });
    },
  });

  const formatHeightWeight = (value: string, limit: number) => {
    const numero = value.replace(/\D/g, '');
    const numeroSemZeros = numero.replace(/^0+/, '');
    const numeroLimitado = numeroSemZeros.slice(0, limit);

    if (numeroLimitado.length === 0) return '';
    const numeroFinal = parseInt(numeroLimitado, 10);
    const valorFormatado = (numeroFinal / 100).toFixed(2); 
     return valorFormatado.replace(',', '.');
  }

  const handleWeightChange = (e: ChangeEvent<HTMLInputElement>) => {
    const formattedValue = formatHeightWeight(e.target.value, 5);
    formik.setFieldValue("personsWeight", formattedValue);
  };

  const handleHeightChange = (e: ChangeEvent<HTMLInputElement>) => {
    const formattedValue = formatHeightWeight(e.target.value, 3);
    formik.setFieldValue("personsHeight", formattedValue);
  };

  return (
    <div className="content-container">
      <LoadingApp showLoading={loadingQuest} />
      {!loadingQuest && (
        <>
          <form>
            {responseQuestionnaire?.listaQuestoesImc?.map((questao, index) => (
              <Box
                key={index}
                className={`input-imc ${index === 1 ? "input-imc-person-weight" : ""
                  }`}
              >
                <Typography
                  className="input-imc-label"
                  style={textStyleAccessibility}
                >
                  {questao.txtQuestao}
                </Typography>
                <label
                  htmlFor={index === 0 ? "personsHeight" : "personsWeight"}
                />
                <TextField
                  id={index === 0 ? "personsHeight" : "personsWeight"}
                  name={index === 0 ? "personsHeight" : "personsWeight"}
                  variant="outlined"
                  placeholder={
                    index === 0 ? "Digite sua altura" : "Digite seu peso"
                  }
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    index === 0 ? handleHeightChange(e) : handleWeightChange(e)
                  }
                  value={
                    index === 0
                      ? formik.values.personsHeight
                      : formik.values.personsWeight
                  }
                  sx={sxTextField}
                  fullWidth
                  InputProps={{
                    style: {
                      ...contrastStyle,
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        {index === 0 ? "m" : "kg"}
                      </InputAdornment>
                    ),
                  }}
                  inputProps={{
                    style: { color: contrastMode ? "white" : "" },
                  }}
                />
                <Typography style={textStyleAccessibility}>
                  {
                    formik.errors[
                    index === 0 ? "personsHeight" : "personsWeight"
                    ]
                  }
                </Typography>
              </Box>
            ))}
          </form>
          <DefaultButton
            style={{ margin: "25px 0px 25px 0px " }}
            className="button-questionnaire-detail"
            text="Continuar"
            disabled={
              !formik.values.personsHeight || !formik.values.personsWeight
            }
            onClick={() => {
              formik.handleSubmit();
            }}
          />
        </>
      )}
    </div>
  );
};
